define('exq-admin/tests/test-helper', ['exports', 'exq-admin/tests/helpers/resolver', 'ember-qunit'], function (exports, _exqAdminTestsHelpersResolver, _emberQunit) {

  (0, _emberQunit.setResolver)(_exqAdminTestsHelpersResolver['default']);

  document.write('<div id="ember-testing-container"><div id="ember-testing"></div></div>');

  QUnit.config.urlConfig.push({ id: 'nocontainer', label: 'Hide container' });
  var containerVisibility = QUnit.urlParams.nocontainer ? 'hidden' : 'visible';
  document.getElementById('ember-testing-container').style.visibility = containerVisibility;
});